/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import * as _ from 'underscore';
import { BaseException } from './base.exception';

export class InvalidArgumentException extends BaseException {
  private strings = {
    name: 'InvalidArgumentException',
    messageHelperText: ' for argument ',
    singleQuote: "'",
    colonSpace: ': '
  };

  constructor(argumentName, message?: string) {
    super(message);
    if (!_.isUndefined(message)) {
      this.message = [
        this.strings.name,
        this.strings.messageHelperText,
        this.strings.singleQuote,
        argumentName,
        this.strings.singleQuote,
        this.strings.colonSpace,
        message
      ].join('');
    } else {
      this.message = argumentName;
    }
  }
}
